(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('commonControlCertification', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                certification: '=',
                layoutRatio: '=?',
                title: '@'
            },
            templateUrl: require('./controlCertification.tpl.html'),
            controller: ['$scope', function ($scope) {
            }],
            link: function (scope, elem, attrs) {
                
                scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                };
            }
        }
    }
})();